var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExcelObject = function SvgExcelObject(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.665 6.83333C1.665 4.25508 3.75508 2.165 6.33333 2.165H17.6667C20.2449 2.165 22.335 4.25508 22.335 6.83333V18.1667C22.335 20.7449 20.2449 22.835 17.6667 22.835H6.33333C3.75508 22.835 1.665 20.7449 1.665 18.1667V6.83333Z",
    stroke: "#495057",
    strokeWidth: 1.33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.137 14.4966H11.1387V10.5",
    stroke: "#495057",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5L8.85473 14.4966",
    stroke: "#495057",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85473 10.5L6 14.4966",
    stroke: "#495057",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1262 10.614C17.1262 10.614 15.0259 10.0588 14.8567 11.3991C14.6876 12.7393 17.5994 12.1213 17.4103 13.5915C17.234 14.9589 15.1422 14.3765 15.1422 14.3765",
    stroke: "#495057",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExcelObject);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNjY1IDYuODMzMzNDMS42NjUgNC4yNTUwOCAzLjc1NTA4IDIuMTY1IDYuMzMzMzMgMi4xNjVIMTcuNjY2N0MyMC4yNDQ5IDIuMTY1IDIyLjMzNSA0LjI1NTA4IDIyLjMzNSA2LjgzMzMzVjE4LjE2NjdDMjIuMzM1IDIwLjc0NDkgMjAuMjQ0OSAyMi44MzUgMTcuNjY2NyAyMi44MzVINi4zMzMzM0MzLjc1NTA4IDIyLjgzNSAxLjY2NSAyMC43NDQ5IDEuNjY1IDE4LjE2NjdWNi44MzMzM1oiIHN0cm9rZT0iIzQ5NTA1NyIgc3Ryb2tlLXdpZHRoPSIxLjMzIi8+CjxwYXRoIGQ9Ik0xMy4xMzcgMTQuNDk2NkgxMS4xMzg3VjEwLjUiIHN0cm9rZT0iIzQ5NTA1NyIgc3Ryb2tlLXdpZHRoPSIxLjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNiAxMC41TDguODU0NzMgMTQuNDk2NiIgc3Ryb2tlPSIjNDk1MDU3IiBzdHJva2Utd2lkdGg9IjEuMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04Ljg1NDczIDEwLjVMNiAxNC40OTY2IiBzdHJva2U9IiM0OTUwNTciIHN0cm9rZS13aWR0aD0iMS4xIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE3LjEyNjIgMTAuNjE0QzE3LjEyNjIgMTAuNjE0IDE1LjAyNTkgMTAuMDU4OCAxNC44NTY3IDExLjM5OTFDMTQuNjg3NiAxMi43MzkzIDE3LjU5OTQgMTIuMTIxMyAxNy40MTAzIDEzLjU5MTVDMTcuMjM0IDE0Ljk1ODkgMTUuMTQyMiAxNC4zNzY1IDE1LjE0MjIgMTQuMzc2NSIgc3Ryb2tlPSIjNDk1MDU3IiBzdHJva2Utd2lkdGg9IjEuMSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";